import { useEffect, useRef } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import Navbar from './Navbar'
import Footer from './Footer'
import { applyDocumentSeo } from '@/shared/utils/siteSeo'
import { hideHeroLcpPrerender } from '@/shared/utils/imageAssets'
// Load once with the public shell so Help/Login/etc. do not inject a second
// Tailwind utilities sheet mid-session (that left Home broken until hard refresh).
import '@/shared/styles/app.css'

const Layout = () => {
  const location = useLocation()
  const prevPathnameRef = useRef(location.pathname)

  useEffect(() => {
    applyDocumentSeo(location.pathname)
    if (location.pathname !== '/') {
      hideHeroLcpPrerender()
    }
  }, [location.pathname])

  // Scroll to top on route change (after paint so sticky nav + new page layout settle)
  useEffect(() => {
    if (prevPathnameRef.current === location.pathname) {
      if (location.hash) {
        const timer = setTimeout(() => {
          document.querySelector(location.hash)?.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }, 100)
        return () => clearTimeout(timer)
      }
      return
    }

    prevPathnameRef.current = location.pathname
    const resetScroll = () => {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
    }
    resetScroll()
    const raf = requestAnimationFrame(resetScroll)
    const timer = window.setTimeout(resetScroll, 50)

    if (location.hash) {
      const hashTimer = setTimeout(() => {
        document.querySelector(location.hash)?.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }, 100)
      return () => {
        cancelAnimationFrame(raf)
        clearTimeout(timer)
        clearTimeout(hashTimer)
      }
    }

    return () => {
      cancelAnimationFrame(raf)
      clearTimeout(timer)
    }
  }, [location.pathname, location.hash])
  
  const relaxOverflowClip =
    location.pathname === '/login' || location.pathname === '/signup'

  return (
    <div 
      className={`min-h-screen flex flex-col bg-white ${relaxOverflowClip ? '' : 'max-md:overflow-x-clip'}`}
    >
      <main className="flex-grow min-w-0">
        <Navbar />
        <Outlet />
      </main>
      <Footer />
    </div>
  )
}

export default Layout

